import React from 'react';
import { BusinessSettingsLayout } from '@/components/business-settings/BusinessSettingsLayout';
import { WorkplaceDetailsForm } from '@/components/business-settings/WorkplaceDetailsForm';
import { BusinessHoursForm } from '@/components/business-settings/BusinessHoursForm';
import { useBusinessHours, useUpdateBusinessHours } from '@/hooks/business/useBusinessHours';
import { DEFAULT_BUSINESS_HOURS_FORM } from '@/services/business/types';
import type { BusinessHoursForm as BusinessHoursFormType, BusinessHours } from '@/services/business/types';

export default function GeneralSettings() {
  // Fetch current business hours
  const { data: businessHoursData, isLoading: isLoadingBusinessHours } = useBusinessHours();
  
  // Mutation for updating business hours
  const updateBusinessHours = useUpdateBusinessHours();

  // Transform database data to form format
  const initialBusinessHoursData: BusinessHoursFormType | undefined = businessHoursData && businessHoursData.length > 0
    ? {
        timezone: businessHoursData[0].timezone,
        businessHours: businessHoursData[0].business_hours as unknown as BusinessHours,
      }
    : undefined;

  // Handle business hours form submission
  const handleBusinessHoursSubmit = async (data: BusinessHoursFormType) => {
    await updateBusinessHours.mutateAsync(data);
  };

  return (
    <BusinessSettingsLayout
      title="General Settings"
      description="Configure your workplace details, display formats, and branding"
    >
      <div className="space-y-6">
        {/* Workplace Details Form */}
        <WorkplaceDetailsForm />

        {/* Business Hours Form */}
        <BusinessHoursForm
          initialData={initialBusinessHoursData || DEFAULT_BUSINESS_HOURS_FORM}
          onSubmit={handleBusinessHoursSubmit}
          isLoading={isLoadingBusinessHours || updateBusinessHours.isPending}
        />
      </div>
    </BusinessSettingsLayout>
  );
}